import React from 'react';

import { useTranslation } from 'react-i18next';

import { Typography, CircularProgress, Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { Img, TitlesWrapper } from './CheckYourEmail.styles';
import { PreOnboardingParams, SetupForm } from '../../PreOnboardingPage';

import SleepioThumbsUp from '@/assets/SleepioThumbsUp.svg';
import LimbotHappy from '@/assets/LimbotHappy.svg';
import { isSpark as isSparkHelper, getProductSupportEmail } from '@/utils/productHelpers';
import {
  ActiveFeatureFlag,
  FeatureFlagProvider,
  useFeatureFlag,
} from '@/hooks/usePostHogFeatureFlags';

type Props = {
  isGeneric?: boolean;
};

const CheckYourEmail: React.FC<Props> = ({ isGeneric }) => {
  const { t } = useTranslation();
  const { product } = useParams<PreOnboardingParams>();
  const isSpark = isSparkHelper(product);

  /* kept logic commented in case we need to implement the oganization naming again
   const { data: organizationNameData } = useQuery(QUERY_ORGANIZATION_BY_SLUG, {
      variables: { organizationSlug: slug },
    }); */

  const variant = useFeatureFlag(ActiveFeatureFlag.EMPLOYER_NAME_EXPERIMENT);

  if (variant === undefined) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  /*  kept logic commented in case we need to implement the oganization naming again
  const subtitle = t(`${checkYourEmailKey}.subtitle`,
    {
      employer: variant === 'employer_name'
        ? organizationNameData?.organizationName.name
        : `${t(`${checkYourEmailKey}.your_employer`)}`,
    }); */
  const checkYourEmailKey = 'coverage.pre_onboarding.sleepio.check_your_email';
  const titleText = t(`${checkYourEmailKey}.generic_title`);
  const subtitleText = t('coverage.sleepio.patient.download_app_subtitle');
  const supportEmail = getProductSupportEmail(isSpark ? 'spark' : 'sleepio');
  const supportSubtitle = `${t('footer.if_you_need_support')} ${supportEmail}`;

  return (
    <>
      <Img
        alt={isSpark ? 'Spark Waving Limbot' : 'Sleepio Thumbsup'}
        style={{ width: '206px' }}
        src={isSpark ? LimbotHappy : SleepioThumbsUp}
      />
      <TitlesWrapper data-is-generic={isGeneric || undefined}>
        <Typography variant="h2">
          {titleText}
        </Typography>
        <Typography style={{ marginTop: 8, marginBottom: 16 }}>
          {subtitleText}
        </Typography>
        <Typography style={{ marginTop: 8, marginBottom: 16 }}>
          {supportSubtitle}
        </Typography>
      </TitlesWrapper>
    </>
  );
};

export default (props: Props) => {
  const { watch } = useFormContext<SetupForm>();

  return (
    <FeatureFlagProvider email={watch('email')}>
      <CheckYourEmail {...props} />
    </FeatureFlagProvider>
  );
};
